const productList = [
  {
    name: "无人车",
    children: [
      {
        id: "car1",
        img: require("@/assets/img/product/car1.png"),
        moreName: "product_car1",
        title: "运输小跟班",
        content: "自动跟随小车"
      },
      {
        id: "car2",
        img: require("@/assets/img/product/car2.png"),
        moreName: "product_car2",
        title: "六驱小跟班",
        content: "自动跟随小车"
      },
      {
        id: "boat1",
        img: require("@/assets/img/product/boat1.png"),
        moreName: "product_boat1",
        title: "CN-T10",
        content: "智能无人船"
      }
    ]
  },
  {
    name: "软件服务",
    children: [
      {
        id: "dmz",
        img: require("@/assets/img/product/rj1.png"),
        moreName: "product_dmz",
        downloadPath: "",
        title: "地面站平台",
        content: "飞控"
      },
      {
        id: "3dView",
        img: require("@/assets/img/product/rj2.png"),
        moreName: "product_solution_v_1",
        downloadPath: "",
        title: "创念云管理平台",
        content: "三维展示平台"
      },
      {
        id: "customSoftware",
        img: require("@/assets/img/product/rj3.png"),
        moreName: "product_solution_v_2",
        downloadPath: "",
        title: "软件定制",
        content: "定制三维平台"
      }
    ]
  },
  {
    name: "无人机",
    children: [
      {
        id: "plane4",
        img: require("@/assets/img/product/plane4.png"),
        moreName: "product_plane4",
        sellPath:
          "https://item.taobao.com/item.htm?spm=a230r.1.14.31.30a342b5dYVDKy&id=626734008942&ns=1&abbucket=5#detail",
        title: "小马2.0",
        content: "四旋翼无人机"
      },
      {
        id: "planekuafu600",
        img: require("@/assets/img/product/kuafu600.png"),
        moreName: "product_planekuafu600",
        sellPath: "",
        title: "夸父600",
        content: "大载重六旋翼航测系统"
      },
      {
        id: "plane6",
        img: require("@/assets/img/product/plane6.png"),
        moreName: "product_plane6",
        sellPath: "",
        title: "墨卡托300",
        content: "六旋翼无人机"
      },
      {
        id: "planeSt",
        img: require("@/assets/img/product/planeSt.png"),
        moreName: "product_planeSt",
        sellPath: "",
        title: "极致PRO",
        content: "碳纤维固定翼无人机"
      },
      {
        id: "planefalcon",
        img: require("@/assets/img/product/falcon.png"),
        moreName: "product_planeFalcon",
        sellPath: "",
        title: "猎鹰",
        content: "LV15固定翼航测系统"
      }
    ]
  },
  {
    name: "激光雷达",
    children: [
      {
        id: "RS100i",
        img: require("@/assets/img/product/LD_RS100i.png"),
        moreName: "product_RS100i",
        title: "RS100i",
        content: "手持激光雷达 RS100i"
      },
      {
        id: "T100",
        img: require("@/assets/img/product/LD_T100.png"),
        moreName: "product_T100",
        title: "T100",
        content: "手持激光雷达 T100"
      },
      {
        id: "CN100C",
        img: require("@/assets/img/product/LD_CN-100C.png"),
        moreName: "product_CN100C",
        sellPath:
          "https://item.taobao.com/item.htm?spm=a1z10.5-c-s.w4002-23918261987.15.795a5b7dQMwiFk&id=651081005834",
        title: "CN-100C",
        content: "激光雷达 CN-100C"
      },
      {
        id: "CN1350w",
        img: require("@/assets/img/product/LD_GS-1350w.png"),
        moreName: "product_CN1350w",
        sellPath:
          "https://item.taobao.com/item.htm?spm=a1z10.5-c-s.w4002-23918261987.21.795a5b7dQMwiFk&id=651468592274",
        title: "CN-1350w",
        content: "车载激光雷达 CN-1350w"
      }
    ]
  }
];

var pdObj = {};
productList.forEach(item => {
  item.children.forEach(pd => {
    pdObj[pd.id] = {
      sellPath: pd.sellPath,
      moreName: pd.moreName,
      downloadPath: pd.downloadPath
    };
  });
});
const productObj = pdObj;

export { productList, productObj };



// WEBPACK FOOTER //
// ./src/store/product.js